import PropTypes from 'prop-types'
import React from 'react'
import { Field } from 'react-final-form'

import RadioButtonInner from './RadioButtonInner'

const RadioButton = ({ name, icons, iconHeight, ...remainingProps }) => (
  <Field
    {...remainingProps}
    name={name}
    type="radio"
    component={RadioButtonInner}
    icons={icons}
    iconHeight={iconHeight}
  />
)

RadioButton.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  icons: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        width: PropTypes.string,
      })
    ),
  iconHeight: PropTypes.string
}

RadioButton.defaultProps = {
  isDisabled: false,
  iconHeight: '100%'
}

export default RadioButton
